import { createRoot } from "react-dom/client";
import App from "./App";

function reportError(message: string, stack?: string, context?: string) {
  try {
    fetch("/api/client-error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message, stack, context }),
    }).catch(() => {});
  } catch {}
}

window.addEventListener("error", (event) => {
  reportError(
    event.error?.message || event.message || "Unknown error",
    event.error?.stack,
    `window.onerror at ${event.filename}:${event.lineno}`
  );
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  reportError(
    reason?.message || String(reason),
    reason?.stack,
    "unhandledrejection"
  );
});

createRoot(document.getElementById("root")!).render(<App />);
